import Drawer from "./drawer";
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import { Box, Toolbar } from "@mui/material";
import OtpChangedCheck from "components/otp-changed-check";
import TwoFAOptInPrompt from "components/two-fa-optin-prompt";

const MainLayout = () => {
  return (
    <Box sx={{ display: "flex", width: "100%", overflowX: "hidden" }}>
      <OtpChangedCheck />
      <TwoFAOptInPrompt />
      <Header />
      <Drawer />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: { xs: 1.5, sm: 3 },
          bgcolor: "background.default",
          minHeight: "calc(100vh - 50px)",
          height: "100%",
          overflowX: "hidden",
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
